/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {LookupService} from '../../../common/service/lookup.service';
import {map, of, tap} from 'rxjs';
import {MapService} from '../../services/map.service';
import {forkJoinDefaultIfEmpty} from '../../../common/observable.utils';

@Injectable({
    providedIn: 'root'
})
export class AttributeViewerTranslationService {
    title = 'AttributeViewerTranslationService';

    constructor(
        private lookupService: LookupService,
        private mapService: MapService
    ) {}

    translateAttributeValues(context: any, features: any[]) {
        console.debug(`${this.title} - translateAttributeValues`);

        if (features.length === 0) {
            return of([]);
        }

        return forkJoinDefaultIfEmpty(
            features.map((f: {attributes: {guid?: string; transientParentId?: string}}) => {
                return forkJoinDefaultIfEmpty(
                    Object.keys(structuredClone(f.attributes))
                        .filter(k => f.attributes[k] !== null && f.attributes[k] !== undefined)
                        .map(k => {
                            const featureAttribute = f.attributes[k];
                            const filteredAttributes = context.attributes.filter((attribute: any) => attribute.prop === k);
                            if (filteredAttributes.length === 0) {
                                return of(null);
                            }
                            return forkJoinDefaultIfEmpty(
                                filteredAttributes.map((attribute: any) => {
                                    if (attribute.featureType === 'angle' && attribute.dms) {
                                        f.attributes[k] = this.formatAngle(featureAttribute);
                                    }

                                    if (attribute.attributeType === 'DOMAIN') {
                                        if (context.tool.type === 'controlPoint' && attribute.lookupService === 'pointTypeLookups') {
                                            attribute.lookupService = 'controlPointTypeLookups';
                                        }

                                        if (attribute.lookupService) {
                                            const lookupServiceName =
                                                f.attributes.transientParentId && attribute.childLookupService
                                                    ? attribute.childLookupService
                                                    : attribute.lookupService;

                                            this.lookupService
                                                .getLookups(lookupServiceName)
                                                .filter((l: any) => l.id === parseInt(featureAttribute))
                                                .forEach(
                                                    (l: any) => (f.attributes[k] = typeof l.description === 'string' ? l.description : l.id)
                                                );
                                        } else if (attribute.customService) {
                                            return this.mapService
                                                .getCustomLookups(attribute.customService + '/' + f.attributes.guid, attribute)
                                                .pipe(
                                                    tap((lookupValues: any[]) =>
                                                        lookupValues
                                                            .filter(l => l.id === parseInt(featureAttribute))
                                                            .forEach(
                                                                l => (f.attributes[k] = typeof l.description === 'string' ? l.description : l.id)
                                                            )
                                                    )
                                                );
                                        }
                                    } else if (attribute.attributeType === 'BOOLEAN' || attribute.attributeType === 'RADIO') {
                                        const attributeValue = String(featureAttribute).toLowerCase();
                                        if (
                                            attributeValue === 't' ||
                                            attributeValue === 'true' ||
                                            attributeValue === 'y' ||
                                            attributeValue === 'yes'
                                        ) {
                                            f.attributes[k] = 'Yes';
                                        } else if (
                                            attributeValue === 'f' ||
                                            attributeValue === 'false' ||
                                            attributeValue === 'n' ||
                                            attributeValue === 'no'
                                        ) {
                                            f.attributes[k] = 'No';
                                        }
                                    }

                                    return of(null);
                                })
                            );
                        })
                );
            })
        ).pipe(map(() => features.slice()));
    }

    private formatAngle(bearing: any) {
        if (!bearing || typeof bearing !== 'string' || !bearing.includes(':')) {
            return '';
        }

        const degreesMinutesSeconds = bearing.split(':');

        const formattedDegrees = parseInt(degreesMinutesSeconds[0], 10).toString();
        const formattedMinutes = degreesMinutesSeconds.length > 1 ? degreesMinutesSeconds[1] : undefined;
        const formattedSeconds = degreesMinutesSeconds.length > 2 ? degreesMinutesSeconds[2] : undefined;

        let formattedBearing = formattedDegrees;

        // if seconds is defined and not "00", append minutes and seconds
        if (formattedSeconds && formattedSeconds !== '0') {
            formattedBearing += ':';
            formattedBearing += formattedMinutes;
            formattedBearing += ':';
            formattedBearing += formattedSeconds;
        } else {
            // seconds is not applicable, add minutes if defined and not "00"
            if (formattedMinutes && formattedMinutes !== '0') {
                formattedBearing += ':';
                formattedBearing += formattedMinutes;
            }
        }

        if (formattedDegrees === '0' && formattedMinutes === '0' && formattedSeconds === '0') {
            formattedBearing += '0';
            formattedBearing += ':';
            formattedBearing += '0';
        }

        return formattedBearing;
    }
}
